import React from "react";
import HeroLayout from "../components/HeroLayout";
import { Link } from "react-router-dom";
const images = require.context("../assets/images", false);

function Tours() {
  return (
    <>
    <HeroLayout>
      <div className="banner-bg" style={{
            backgroundImage:
            `linear-gradient(#370b2e66, #370b2e66), url(${images("./tours.jpeg")})`
        }}
        >
        <div className="container">
            <div className="inner-banner-content full-width center color-white mt-5">
            <h1>The Golden Triangle Tours</h1>
            </div>
        </div>
        </div>

    </HeroLayout>
    <div className="services">
  <div className="inner-services paddingY-70">
    <div className="container">
      <div className="heading center">
        <p>VIP | PRIVATE | LUXURY | PERSONALIZED</p>
        <h2>Our Most Popular India Tours</h2>
      </div>
      <div className="service-slider">
        <div className="row">
          <div className="col-md-3">
            <div className="service-slider-card mb-4">
              <Link to="/golden-triangle-short-tour/"><img src={images("./Golden-Traingle-shortTour-India.jpg")} alt="lasik" /></Link>
              <Link to="/golden-triangle-short-tour/"><h3 className="mb-4">Golden Triangle - Short Tour</h3></Link>
              <div className="sectionheight">

              <p>
                <img src={images("./map-marker.svg")} /> Delhi, Agra, Jaipur
              </p>
              <p>
                <img src={images("./clock.svg")} /> 3 Nights / 4 Days
              </p>
              </div>
              <div className="btns-group mt-4">
                <Link to="/golden-triangle-short-tour/#enquire" className="grey-btn">
                  Book Now
                </Link>
                <Link to="/golden-triangle-short-tour/" className="grey-btn">
                  Details
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="service-slider-card mb-4">
              <Link to="/golden-triangle-standard-tour/"><img src={images("./goldentrianglestandardtour.jpg")} alt="lasik" /></Link>
              <Link to="/golden-triangle-standard-tour/"><h3 className="mb-4">Golden Triangle - Standard Tour</h3></Link>
              <div className="sectionheight">

              <p>
                <img src={images("./map-marker.svg")} /> Delhi, Agra, Jaipur
              </p>
              <p>
                <img src={images("./clock.svg")} /> 6 Nights / 7 Days
              </p>
              </div>
              <div className="btns-group mt-4">
                <Link to="/golden-triangle-standard-tour/#enquire" className="grey-btn">
                  Book Now
                </Link>
                <Link to="/golden-triangle-standard-tour/" className="grey-btn">
                  Details
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="service-slider-card mb-4">
              <Link to="/golden-triangle-oberoi-hotels/"><img src={images("./oberoihotel.jpg")} alt="lasik" /></Link>
              <Link to="/golden-triangle-oberoi-hotels/"><h3 className="mb-4">Golden Triangle - Oberoi Hotels</h3></Link>
              <div className="sectionheight">

              <p>
                <img src={images("./map-marker.svg")} /> Delhi, Agra, Jaipur
              </p>
              <p>
                <img src={images("./clock.svg")} /> 6 Nights / 7 Days
              </p>
              </div>
              <div className="btns-group mt-4">
                <Link to="/golden-triangle-oberoi-hotels/#enquire" className="grey-btn">
                  Book Now
                </Link>
                <Link to="/golden-triangle-oberoi-hotels/" className="grey-btn">
                  Details
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="service-slider-card mb-4">
              <Link to="/golden-triangle-tiger-tour/"><img src={images("./Golden-Triangle-Tiger-Tour.jpg")} alt="lasik" /></Link>
              <Link to="/golden-triangle-tiger-tour/"><h3 className="mb-4">Golden Triangle & Tiger Tour</h3></Link>
              <div className="sectionheight">

              <p>
                <img src={images("./map-marker.svg")} /> Delhi, Agra, Jaipur, Ranthambhore National Park
              </p>
              <p>
                <img src={images("./clock.svg")} /> 8 Nights / 9 Days
              </p>
              </div>
              <div className="btns-group mt-4">
                <Link to="/golden-triangle-tiger-tour/#enquire" className="grey-btn">
                  Book Now
                </Link>
                <Link to="/golden-triangle-tiger-tour/" className="grey-btn">
                  Details
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="service-slider-card mb-4">
              <Link to="/best-luxury-private-india-tour/"><img src={images("./aboutus_tour.webp")} alt="Best of India Tour" /></Link>
              <Link to="/best-luxury-private-india-tour/"><h3 className="mb-4">Best of India Tour</h3></Link>
              <div className="sectionheight">
              <p>
                <img src={images("./map-marker.svg")} alt="" /> Delhi, Agra, Jaipur, Rawla Narlai, Udaipur
              </p>
              <p>
                <img src={images("./clock.svg")} alt="" /> 9-14 Nights / 10-15 Days
              </p>
              </div>
              <div className="btns-group mt-4">
                <Link to="/best-luxury-private-india-tour/#enquire" className="grey-btn">
                  Book Now
                </Link>
                <Link to="/best-luxury-private-india-tour/" className="grey-btn">
                  Details
                </Link>
              </div>
            </div>
          </div>
          
          
          <div className="col-md-12">
  <div className="tailor-made-card-btn">
    <p className="center">
      If you are not into brochure tours and looking for something especially
      customized as per your preferences and travel style, our team will do that
      for you happily.    
    </p>
    <Link to="/luxury-golden-triangle-enquiry" className="btn-link">
      <img src={images("./11.png")} /> TAILOR MADE TOUR
    </Link>
  </div>
</div>

        </div>
      </div>
    </div>
  </div>
</div>
<div className="service-btn-list paddingY-70">
  <div className="container">
    <div className="row">
      <div className="col-md-3">
        <div className="service-btn-card center">
          <div className="icon-box mb-4">
            <img src={images("./22.png")} />
          </div>
          <h3 className="mb-3">Luxury Hotels List</h3>
          <p className="mb-3 carsectn">5-star Hotels in Delhi, Agra &amp; jaipur</p>
          <Link to="/5-star-luxury-hotels" className="secondary-btn">
            View More <img src={images("./arrow-right-btn.svg")} />
          </Link>
        </div>
      </div>
      <div className="col-md-3 mobilemt-20">
        <div className="service-btn-card center">
          <div className="icon-box mb-4">
            <img src={images("./car-d.png")} />
          </div>
          <h3 className="mb-3">Car Details</h3>
          <p className="mb-3 carsectn">Luxury vehicles for you comfort</p>
          <Link to="/car-details" className="secondary-btn">
            View More <img src={images("./arrow-right-btn.svg")} />
          </Link>
        </div>
      </div>
      <div className="col-md-3 mobilemt-20">
        <div className="service-btn-card center">
          <div className="icon-box mb-4">
            <img src={images("./mapp.png")} />
          </div>
          <h3 className="mb-3">Tour Extensions</h3>
          <p className="mb-3">Extent to Varansi, Udaipur, Kerla &amp; More</p>
          <Link to="/golden-triangle-tour-extensions" className="secondary-btn">
            View More <img src={images("./arrow-right-btn.svg")} />
          </Link>
        </div>
      </div>
      <div className="col-md-3 mobilemt-20">
        <div className="service-btn-card center">
          <div className="icon-box mb-4">
            <img src={images("./star-s.png")} />
          </div>
          <h3 className="mb-3">Authentic Experiences</h3>
          <p className="mb-3">Unique cultural experiences across India</p>
          <Link to="/authentic-indian-experiences" className="secondary-btn">
            View More <img src={images("./arrow-right-btn.svg")} />
          </Link>
        </div>
      </div>
    </div>
  </div>
</div>

    </>
  );
}

export default Tours;
